import { render, staticRenderFns } from "./qualificationQuery.vue?vue&type=template&id=50f51525&scoped=true&"
import script from "./qualificationQuery.vue?vue&type=script&lang=js&"
export * from "./qualificationQuery.vue?vue&type=script&lang=js&"
import style0 from "./qualificationQuery.vue?vue&type=style&index=0&id=50f51525&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f51525",
  null
  
)

export default component.exports